// Code generated by OpenAPI Generator (https://openapi-generator.tech), manual changes will be lost - read more on https://github.com/algolia/api-clients-automation. DO NOT EDIT.

import type { Region as AbtestingRegion, RegionOptions as AbtestingRegionOptions } from '@algolia/client-abtesting';
import type { Region as AnalyticsRegion, RegionOptions as AnalyticsRegionOptions } from '@algolia/client-analytics';
import type { Region as InsightsRegion, RegionOptions as InsightsRegionOptions } from '@algolia/client-insights';
import type { Region as IngestionRegion, RegionOptions as IngestionRegionOptions } from '@algolia/ingestion';

import type {
  Region as PersonalizationRegion,
  RegionOptions as PersonalizationRegionOptions,
} from '@algolia/client-personalization';
import type {
  Region as QuerySuggestionsRegion,
  RegionOptions as QuerySuggestionsRegionOptions,
} from '@algolia/client-query-suggestions';

import type { Status } from '@algolia/client-abtesting';
import type { ClientOptions } from '@algolia/client-common';
import type { EventType } from '@algolia/client-personalization';
import type {
  Action,
  AdvancedSyntaxFeatures,
  AlternativesAsExact,
  Anchoring,
  AroundPrecision,
  AroundRadius,
  AroundRadiusAll,
  AutomaticFacetFilter,
  AutomaticFacetFilters,
  Banner,
  BannerImage,
  BannerImageUrl,
  BannerLink,
  BaseIndexSettings,
  BaseSearchParams,
  BaseSearchParamsWithoutQuery,
  BaseSearchResponse,
  BooleanString,
  Condition,
  Consequence,
  ConsequenceHide,
  ConsequenceParams,
  ConsequenceQuery,
  ConsequenceQueryObject,
  CustomDeleteProps,
  CustomGetProps,
  CustomPostProps,
  CustomPutProps,
  DeleteSourceProps,
  DeletedAtResponse,
  Distinct,
  Edit,
  EditType,
  ErrorBase,
  ExactOnSingleWordQuery,
  Exhaustive,
  FacetFilters,
  FacetHits,
  FacetOrdering,
  FacetStats,
  Facets,
  GetTaskProps,
  HighlightResult,
  HighlightResultOption,
  Hit,
  IgnorePlurals,
  IndexSettingsAsSearchParams,
  InsideBoundingBox,
  Languages,
  MatchLevel,
  MatchedGeoLocation,
  Mode,
  NumericFilters,
  OptionalFilters,
  OptionalWords,
  Params,
  Personalization,
  Promote,
  PromoteObjectID,
  PromoteObjectIDs,
  QueryType,
  Range,
  RankingInfo,
  ReRankingApplyFilter,
  Redirect,
  RedirectRuleIndexData,
  RedirectRuleIndexMetadata,
  RedirectURL,
  RemoveStopWords,
  RemoveWordsIfNoResults,
  RenderingContent,
  SearchForFacetValuesProps,
  SearchForFacetValuesRequest,
  SearchForFacetValuesResponse,
  SearchHits,
  SearchPagination,
  SearchParams,
  SearchParamsObject,
  SearchParamsQuery,
  SearchResponse,
  SemanticSearch,
  SnippetResult,
  SnippetResultOption,
  SortRemainingBy,
  Source,
  SupportedLanguage,
  TagFilters,
  TaskStatus,
  TimeRange,
  TypoTolerance,
  TypoToleranceEnum,
  Value,
  Widgets,
} from '@algolia/client-search';
import { apiClientVersion } from '@algolia/client-search';

export * from '@algolia/client-abtesting';
export * from '@algolia/client-analytics';
export * from '@algolia/client-insights';
export * from '@algolia/client-personalization';
export * from '@algolia/client-query-suggestions';
export * from '@algolia/client-search';
export * from '@algolia/ingestion';
export * from '@algolia/monitoring';
export * from '@algolia/recommend';

export type Region =
  | AbtestingRegion
  | AnalyticsRegion
  | IngestionRegion
  | InsightsRegion
  | PersonalizationRegion
  | QuerySuggestionsRegion;
export type RegionOptions =
  | AbtestingRegionOptions
  | AnalyticsRegionOptions
  | IngestionRegionOptions
  | InsightsRegionOptions
  | PersonalizationRegionOptions
  | QuerySuggestionsRegionOptions;

export type {
  AbtestingRegion,
  AbtestingRegionOptions,
  AnalyticsRegion,
  AnalyticsRegionOptions,
  EventType,
  IngestionRegion,
  IngestionRegionOptions,
  InsightsRegion,
  InsightsRegionOptions,
  PersonalizationRegion,
  PersonalizationRegionOptions,
  QuerySuggestionsRegion,
  QuerySuggestionsRegionOptions,
  Status,
};

export type {
  Action,
  AdvancedSyntaxFeatures,
  AlternativesAsExact,
  Anchoring,
  AroundPrecision,
  AroundRadius,
  AroundRadiusAll,
  AutomaticFacetFilter,
  AutomaticFacetFilters,
  Banner,
  BannerImage,
  BannerImageUrl,
  BannerLink,
  BaseIndexSettings,
  BaseSearchParams,
  BaseSearchParamsWithoutQuery,
  BaseSearchResponse,
  BooleanString,
  Condition,
  Consequence,
  ConsequenceHide,
  ConsequenceParams,
  ConsequenceQuery,
  ConsequenceQueryObject,
  CustomDeleteProps,
  CustomGetProps,
  CustomPostProps,
  CustomPutProps,
  DeleteSourceProps,
  DeletedAtResponse,
  Distinct,
  Edit,
  EditType,
  ErrorBase,
  ExactOnSingleWordQuery,
  Exhaustive,
  FacetFilters,
  FacetHits,
  FacetOrdering,
  FacetStats,
  Facets,
  GetTaskProps,
  HighlightResult,
  HighlightResultOption,
  Hit,
  IgnorePlurals,
  IndexSettingsAsSearchParams,
  InsideBoundingBox,
  Languages,
  MatchLevel,
  MatchedGeoLocation,
  Mode,
  NumericFilters,
  OptionalFilters,
  OptionalWords,
  Params,
  Personalization,
  Promote,
  PromoteObjectID,
  PromoteObjectIDs,
  QueryType,
  Range,
  RankingInfo,
  ReRankingApplyFilter,
  Redirect,
  RedirectRuleIndexData,
  RedirectRuleIndexMetadata,
  RedirectURL,
  RemoveStopWords,
  RemoveWordsIfNoResults,
  RenderingContent,
  SearchForFacetValuesProps,
  SearchForFacetValuesRequest,
  SearchForFacetValuesResponse,
  SearchHits,
  SearchPagination,
  SearchParams,
  SearchParamsObject,
  SearchParamsQuery,
  SearchResponse,
  SemanticSearch,
  SnippetResult,
  SnippetResultOption,
  SortRemainingBy,
  Source,
  SupportedLanguage,
  TagFilters,
  TaskStatus,
  TimeRange,
  TypoTolerance,
  TypoToleranceEnum,
  Value,
  Widgets,
};

export { apiClientVersion };

/**
 * Options forwarded to the client initialized via the `init` method.
 */
export type InitClientOptions = Partial<{
  /**
   * App to target with the initialized client, defaults to the `algoliasearch` appId.
   */
  appId: string;
  /**
   * API key of the targeted app ID, defaults to the `algoliasearch` apiKey.
   */
  apiKey: string;
  options: ClientOptions;
}>;
